/**
 * @file
 * Aggregate of all BassBlocks
 */
import { prop, ValueOf } from '../types';

import Aoy from './Aoy/Aoy';
import AoyTabs from './Aoy/AoyTabs';
import AtTheTanks from './AtTheTanks/AtTheTanks';
import BassTabs from './BassTabs/BassTabs';
import BasstrakkLeaderboardOpen from './BasstrakkLeaderboard/BasstrakkLeaderboardOpen';
import BasstrakkMap from './BasstrakkMap/BasstrakkMap';
import BasstrakkTable from './BasstrakkTable/BasstrakkTable';
import FinalResults from './FinalResults/FinalResults';
import HistoricalStats from './HistoricalStats/HistoricalStats';
import HistoricalTable from './HistoricalTable/HistoricalTable';
import Leaderboard from './Leaderboard/Leaderboard';
import OnStage from './OnStage/OnStage';
import RequestLogs from './RequestLogs/RequestLogs';
import WeightLeader from './WeightLeader/WeightLeader';

export const blocks = {
  Aoy,
  AoyTabs,
  AtTheTanks,
  BassTabs,
  BasstrakkLeaderboardOpen,
  BasstrakkMap,
  BasstrakkTable,
  FinalResults,
  HistoricalStats,
  HistoricalTable,
  Leaderboard,
  OnStage,
  RequestLogs,
  WeightLeader,
};

export type IBassBlocks = typeof blocks;
export type BassBlockNameTypes = keyof IBassBlocks;
export type BassBlockTypeTypes = ValueOf<IBassBlocks>;

export default (blockLookup: BassBlockNameTypes): BassBlockTypeTypes =>
  prop(blocks, blockLookup);
